module.exports = __webpack_public_path__ + "img/Artboard4.348cf3a3.webp";